import { render, staticRenderFns } from "./NewHeader.vue?vue&type=template&id=499a0dae&scoped=true&"
import script from "./NewHeader.vue?vue&type=script&lang=js&"
export * from "./NewHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewHeader.vue?vue&type=style&index=0&id=499a0dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a0dae",
  null
  
)

export default component.exports